module.exports = __webpack_public_path__ + "img/03.ce1da2a5.jpg";